import React from 'react';
import { Poppins } from 'src/common';
import colors from 'src/theme/colors';
import styled from 'styled-components';

export const HeadTitle = styled(Poppins)`
  color: ${colors.cflowerBlue};
  font-weight: 500;
`;
